import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

import Home from './pages/Home';
import Login from './pages/Login';
import AdminLogin from './pages/AdminLogin';
import Portal from './pages/Portal';
import Dashboard from './pages/Dashboard';
import Students from './pages/Students';
import StudentForm from './pages/StudentForm';
import StudentView from './pages/StudentView';
import Rooms from './pages/Rooms';
import Fees from './pages/Fees';
import Staff from './pages/Staff';
import Attendance from './pages/Attendance';
import Salaries from './pages/Salaries';
import Bills from './pages/Bills';
import Maintenance from './pages/Maintenance';
import Reports from './pages/Reports';
import Customization from './pages/Customization';
import UserAccounts from './pages/UserAccounts';
import UserReports from './pages/UserReports';
import Warden from './pages/Warden';

function RoleRoute({ roles, children }) {
  const { isAuth, role } = useAuth();
  if (!isAuth) return <Navigate to={roles.includes('admin') ? '/admin/login' : '/login'} replace />;
  if (!roles.includes(role)) return <Navigate to={role === 'admin' ? '/admin' : '/portal'} replace />;
  return children;
}

function AppRoutes() {
  const { isAdmin, isPortalUser } = useAuth();
  const admin = page => <RoleRoute roles={['admin']}>{page}</RoleRoute>;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={isPortalUser ? <Navigate to="/portal" replace /> : <Login />} />
      <Route path="/portal" element={<RoleRoute roles={['student', 'staff']}><Portal /></RoleRoute>} />

      <Route path="/admin/login" element={isAdmin ? <Navigate to="/admin" replace /> : <AdminLogin />} />
      <Route path="/admin" element={admin(<Dashboard />)} />
      <Route path="/admin/students" element={admin(<Students />)} />
      <Route path="/admin/students/add" element={admin(<StudentForm />)} />
      <Route path="/admin/students/:id" element={admin(<StudentView />)} />
      <Route path="/admin/students/:id/edit" element={admin(<StudentForm />)} />
      <Route path="/admin/rooms" element={admin(<Rooms />)} />
      <Route path="/admin/fees" element={admin(<Fees />)} />
      <Route path="/admin/staff" element={admin(<Staff />)} />
      <Route path="/admin/warden" element={admin(<Warden />)} />
      <Route path="/admin/attendance" element={admin(<Attendance />)} />
      <Route path="/admin/salaries" element={admin(<Salaries />)} />
      <Route path="/admin/bills" element={admin(<Bills />)} />
      <Route path="/admin/maintenance" element={admin(<Maintenance />)} />
      <Route path="/admin/reports" element={admin(<UserReports />)} />
      <Route path="/admin/monthly-report" element={admin(<Reports />)} />
      <Route path="/admin/customization" element={admin(<Customization />)} />
      <Route path="/admin/user-accounts" element={admin(<UserAccounts />)} />
      <Route path="/admin/user-reports" element={<Navigate to="/admin/reports" replace />} />

      <Route path="/dashboard" element={<Navigate to="/admin" replace />} />
      <Route path="/customization" element={<Navigate to="/admin/customization" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return <AuthProvider><BrowserRouter><AppRoutes /></BrowserRouter></AuthProvider>;
}
